import { updatePrimaryPalette } from "@primevue/themes";
import Aura from "@primevue/themes/aura";
import PrimeVue from "primevue/config";
import { createApp } from "vue";
import Vue3TouchEvents from "vue3-touch-events";
import App from "./App.vue";
import router from "./router";

import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmPopup from "primevue/confirmpopup";
import DataView from "primevue/dataview";
import DatePicker from "primevue/datepicker";
import Dialog from "primevue/dialog";
import Drawer from "primevue/drawer";
import FloatLabel from "primevue/floatlabel";
import IconField from "primevue/iconfield";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputIcon from "primevue/inputicon";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Menu from "primevue/menu";
import Popover from "primevue/popover";
import ProgressSpinner from "primevue/progressspinner";
import Select from "primevue/select";
import Skeleton from "primevue/skeleton";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import ToggleSwitch from "primevue/toggleswitch";

import "primeicons/primeicons.css";
import "./styles/Global.css";

import axios from "axios";

const hostBackend = process.env.VUE_APP_BACKEND_URL || window.location.origin;
const hostname = window.location.hostname;
const app = createApp(App);

app.component("Button", Button);
app.component("InputText", InputText);
app.component("DataView", DataView);
app.component("DatePicker", DatePicker);
app.component("Drawer", Drawer);
app.component("Select", Select);
app.component("AutoComplete", AutoComplete);
app.component("DatePicker ", DatePicker);
app.component("Dialog", Dialog);
app.component("InputNumber", InputNumber);
app.component("Textarea", Textarea);
app.component("ToggleSwitch", ToggleSwitch);
app.component("Skeleton", Skeleton);
app.component("ConfirmPopup", ConfirmPopup);
app.component("Toast", Toast);
app.component("ConfirmDialog", ConfirmDialog);
app.component("Menu", Menu);
app.component("InputMask", InputMask);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Checkbox", Checkbox);
app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("IconField", IconField);
app.component("InputIcon", InputIcon);
app.component("InputGroup", InputGroup);
app.component("InputGroupAddon", InputGroupAddon);
app.component("Popover", Popover);
app.component("FloatLabel", FloatLabel);
app.component("Tag", Tag);

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: "p",
      darkModeSelector: ".my-app-dark",
      cssLayer: {
        name: "primevue",
        order: "global, Primevue, tailwind-utilities",
      },
    },
  },
  locale: {
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    emptyFilterMessage: "Nenhum resultado encontrado",
    emptyMessage: "Nenhum registro encontrado",
    invalidDateMessage: "Data inválida",
  },
});

const changePrimaryColor = () => {
  updatePrimaryPalette({
    50: "{blue.50}",
    100: "{blue.100}",
    200: "{blue.200}",
    300: "{blue.300}",
    400: "{blue.400}",
    500: "{blue.500}",
    600: "{blue.600}",
    700: "{blue.700}",
    800: "{blue.800}",
    900: "{blue.900}",
    950: "{blue.950}",
  });
};

changePrimaryColor();

app.use(ConfirmationService);
app.use(ToastService);
app.use(router);
app.use(Vue3TouchEvents);
// app.config.globalProperties.$urlBackend = `http://${hostBackend}:${portaBackend}`;
app.config.globalProperties.$urlBackend = hostBackend;
app.config.globalProperties.$hostname = `http://${hostname}`;
app.config.globalProperties.$axios = axios;
app.mount("#app");
